if (!customElements.get('multicolumn-slides')) {
  class MulticolumnSlides extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.multicolumn-card__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-slide-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.slideDot, 10), true));
      });

      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.touches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchStartX === undefined) return;
        const deltaX = event.changedTouches[0].clientX - this.touchStartX;
        this.touchStartX = undefined;
        if (Math.abs(deltaX) < 40) return;
        this.go(deltaX < 0 ? this.index + 1 : this.index - 1, true);
      }, { passive: true });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(target, userAction) {
      const count = this.slides.length;
      this.index = (target + count) % count;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      if (userAction && !this.matches(':hover') && !this.contains(document.activeElement)) this.start();
    }

    start() {
      this.stop();
      if (this.reducedMotion) return;
      this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  customElements.define('multicolumn-slides', MulticolumnSlides);
}
